import React from 'react';
import ContactForm from '../ContactForm';
import { Box, Container, Typography } from '@mui/material';
import { getConditionsSettings } from '../../utils';
import { useOutletContext } from 'react-router-dom';

export function Contact() {
  const infos = useOutletContext();
  const { showContact } = getConditionsSettings(infos.settings);

  if (!showContact) return null;

  return (
    <Container
      sx={{
        paddingTop: '32px',
        paddingBottom: '56px',
      }}
    >
      <Box
        sx={{
          maxWidth: '600px',
          margin: 'auto',
        }}
      >
        <Typography variant="h3" sx={{ textAlign: 'center' }}>
          Contactez-nous
        </Typography>
        <ContactForm />
      </Box>
    </Container>
  );
}
